export default "__VITE_ASSET__CU9$1doo__"